<template>
  <section>
    <b-field>
      <b-select v-model="value" size="is-small">
        <option v-for="option in selectableCabins" :value="option.key" :key="option.key">
          {{ option.label }}
        </option>
      </b-select>
    </b-field>
  </section>
</template>

<script>
export default {
  props: {
    selectedValue: {
      type: String,
      default: () => 'Y' 
    },
    cabinOptions: {
      type: Array,
      default: () => [] // Ensures cabinOptions is always an array
    }
  },
  data() {
    return {
      allCabins: [
        { key: 'Y', label: 'Economy' },
        { key: 'M', label: 'Standard Economy' },
        { key: 'W', label: 'Premium Economy' },
        { key: 'C', label: 'Business' },
        { key: 'F', label: 'First' }
      ]
    };
  },
  computed: {
    selectableCabins() {
      // Filter cabins based on cabinOptions if provided
      let cabins = this.allCabins;
      if (Array.isArray(this.cabinOptions) && this.cabinOptions.length > 0) {
        cabins = cabins.filter(item => this.cabinOptions.includes(item.key));
      }

      // If both 'C' and 'F' are available, remove them and add the combined option.
      const hasC = cabins.some(cabin => cabin.key === 'C');
      const hasF = cabins.some(cabin => cabin.key === 'F');
      if (hasC && hasF) {
        cabins = cabins.filter(cabin => !['C', 'F'].includes(cabin.key));
        cabins.push({ key: 'C|F', label: 'Business/First' });
      }

      return cabins;
    },
    value: {
      get() {
        // Check if the current selectedValue exists in selectableCabins, otherwise use the first available cabin
        const selected = this.selectedValue;
        const availableCabins = this.selectableCabins;

        // If the selected value is valid and available in selectableCabins, use it, else fallback to the first available cabin
        return availableCabins.some(cabin => cabin.key === selected) ? selected : availableCabins[0]?.key;
      },
      set(val) {

        this.$emit('input', val);
      }
    },
  }
};
</script>

<style scoped></style>
